export const Types = {
    OPEN_ADD_SITE_LIST_MODAL: "OPEN_ADD_SITE_LIST_MODAL",
    ADD_SITE_LIST: "ADD_SITE_LIST",
    GET_EDIT_SITE_LIST: "GET_EDIT_SITE_LIST",
    CLEAR_SITE_LIST_STATES: "CLEAR_SITE_LIST_STATES",
  };
